type Environments = 'dev' | 'staging' | 'prod';

const environments = {
  dev: {
    API_URL: 'http://localhost:8081/graphql/',
    USER_API_URL: 'http://localhost:8081',
    WORDPRESS_URL: 'http://localhost:8090/wp-json/operatic_tools/api',
    WEBSITE_URL: 'https://localhost:8080',

    DIASTASIS_RECTI_VIDEO_URL: 'https://jw-cdn.every-mother.com/manifests/MeBYDKpz.m3u8',
    DIASTASIS_RECTI_VIDEO_THUMBNAIL: 'https://assets-jpcust.jwpsrv.com/thumbnails/6zllbzsk-480.jpg',

    ALLOWED_UNUM_ORIGIN: 'http://localhost:8080',

    ONBOARDING_LATEST_VERSION: Number(process.env.REACT_APP_ONBOARDING_LATEST_VERSION) || 5,
    ONBOARDING_WEB_LATEST_VERSION: Number(process.env.ONBOARDING_WEB_LATEST_VERSION) || 1,
    MOBILE_SUCCESS_CHECKOUT_REDIRECT: 'every-mother://successful_web_checkout',

    // Chargebee Plans
    chargebeePlans: {
      MONTHLY: 'Membership-Staging-Monthly-Trial-USD-Monthly',
      QUARTERLY: 'Membership-Staging-Quarterly-Trial-USD-Every-3-months',
      BIANNUAL: 'Membership-Staging-Biannual-Trial-USD-Every-6-months',
      ANNUAL: 'Membership-Staging-Annual-Trial-USD-Yearly',
    },
  },

  staging: {
    API_URL: 'https://user-api.staging.every-mother.com/graphql/',
    USER_API_URL: 'https://user-api.staging.every-mother.com',
    WORDPRESS_URL: 'https://staging.every-mother.com/wp-json/operatic_tools/api',
    WEBSITE_URL: 'https://staging.every-mother.com',

    DIASTASIS_RECTI_VIDEO_URL: 'https://jw-cdn.every-mother.com/manifests/MeBYDKpz.m3u8',
    DIASTASIS_RECTI_VIDEO_THUMBNAIL: 'https://assets-jpcust.jwpsrv.com/thumbnails/6zllbzsk-480.jpg',

    ALLOWED_UNUM_ORIGIN: 'https://staging.every-mother.com',

    ONBOARDING_LATEST_VERSION: Number(process.env.REACT_APP_ONBOARDING_LATEST_VERSION) || 5,
    ONBOARDING_WEB_LATEST_VERSION: Number(process.env.ONBOARDING_WEB_LATEST_VERSION) || 1,
    MOBILE_SUCCESS_CHECKOUT_REDIRECT: 'every-mother://successful_web_checkout',

    // Chargebee Plans
    chargebeePlans: {
      MONTHLY: 'Membership-Staging-Monthly-Trial-USD-Monthly',
      QUARTERLY: 'Membership-Staging-Quarterly-Trial-USD-Every-3-months',
      BIANNUAL: 'Membership-Staging-Biannual-Trial-USD-Every-6-months',
      ANNUAL: 'Membership-Staging-Annual-Trial-USD-Yearly',
    },
  },

  prod: {
    API_URL: 'https://user-api.every-mother.com/graphql/',
    USER_API_URL: 'https://user-api.every-mother.com',
    WORDPRESS_URL: 'https://every-mother.com/wp-json/operatic_tools/api',
    WEBSITE_URL: 'https://every-mother.com',

    DIASTASIS_RECTI_VIDEO_URL: 'https://jw-cdn.every-mother.com/manifests/MeBYDKpz.m3u8',
    DIASTASIS_RECTI_VIDEO_THUMBNAIL: 'https://assets-jpcust.jwpsrv.com/thumbnails/6zllbzsk-480.jpg',

    ALLOWED_UNUM_ORIGIN: 'https://carehub.unum.com/',

    ONBOARDING_LATEST_VERSION: Number(process.env.REACT_APP_ONBOARDING_LATEST_VERSION) || 5,
    ONBOARDING_WEB_LATEST_VERSION: Number(process.env.ONBOARDING_WEB_LATEST_VERSION) || 1,
    MOBILE_SUCCESS_CHECKOUT_REDIRECT: 'every-mother://successful_web_checkout',

    // Chargebee Plans
    chargebeePlans: {
      MONTHLY: 'Member-Monthly-1month',
      QUARTERLY: 'Member-Quarterly-3months',
      BIANNUAL: 'Member-Biannual-USD-Every-6-months',
      ANNUAL: 'Member-Annual-Yearly',
    },
  },
} as const;

const environment = process.env.REACT_APP_ENV as Environments;

export const config = environment ? environments[environment] : environments.dev;
